import { PRICES } from "@dransay/api/models";
import { useTranslation } from "react-i18next";
import { useCurrencyPrice } from "~/hooks/use-currency-price.hook";

export function CartPrescriptionFee() {
	const { t } = useTranslation("cart");
	const { getCurrencyPrice } = useCurrencyPrice();
	return (
		<div className="flex justify-between items-center">
			<p className="text-body-sm text-gray-700">
				{t("prescriptionSummaryLabel")}
			</p>
			<span
				className="text-body-sm whitespace-nowrap text-gray-700"
				suppressHydrationWarning
			>
				{getCurrencyPrice(PRICES.onlineService)}
			</span>
		</div>
	);
}
